module.exports = __webpack_public_path__ + "img/card_title_huge.36156183.png";